<template>
  <el-table-column :label="label" :prop="prop" class-name="owner-code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '所有者'
    },
    prop: {
      type: String,
      default: 'owner_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.owner-code {
      width: 10em;
    }
  }
}
</style>
